import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'
import type {TGameId, TGameTime} from '@kapitalist/contract/types'
import * as M from '@kapitalist/utils/Map'
import type PastGamePosition from '~/models/game/PastGamePosition'

type TPastGamePositionStateData = {
  // key: timestamp/etc
  pastGamePositionsMap: Map<string, PastGamePosition>
}

export type PastGamePositionsState = {
  games: Map<TGameId, TPastGamePositionStateData>
}

type TAddToGamePayload = {
  gameId: TGameId
  currentTime: TGameTime
  pastGamePositions: PastGamePosition[]
}

const initialState: PastGamePositionsState = {
  games: new Map(),
}

const pastGamePositionsSlice = createSlice({
  name: 'pastGamePositions',
  initialState,
  reducers: {
    addPastGamePositionsForGame(
      // I guess Redux (and/or its typings) doesn't like something about my model
      // class instances in here, but it works, so too bad.
      state_: any, // PastGamePositionsState
      action: PayloadAction<TAddToGamePayload>
    ) {
      const state = state_ as PastGamePositionsState

      let games: Map<TGameId, TPastGamePositionStateData> = M.clone(state.games)
      let pastGamePositionsMap = M.clone(
        games.get(action.payload.gameId)?.pastGamePositionsMap ?? new Map()
      )
      pastGamePositionsMap = M.addEntries(
        action.payload.pastGamePositions.map(pgp => [
          pgp.date.toISOString() + pgp.gamePosition.time,
          pgp,
        ]),
        pastGamePositionsMap
      )

      // we sometimes roll games backwards during debugging, so clear anything "in the future"
      pastGamePositionsMap = M.reject(
        pgp => pgp.gamePosition.time >= action.payload.currentTime,
        pastGamePositionsMap
      )

      games = M.set(action.payload.gameId, {pastGamePositionsMap}, games)

      return {games}
    },
  },
})

const {addPastGamePositionsForGame} = pastGamePositionsSlice.actions
export {addPastGamePositionsForGame}
export default pastGamePositionsSlice.reducer
